import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const FetchOriginalWebUrlLinkData = new ReduxAsyncAction<'FETCH_ORIGINAL_WEB_URL_LINK_DATA', string, Record<string, any>>(
  'FETCH_ORIGINAL_WEB_URL_LINK_DATA'
);

FetchOriginalWebUrlLinkData.registerRequest(async (originalWebUrl: string) => {
  try {
    const { data } = await dash_api.post<Record<string, any>>('/v1/scraper/metadata', {
      uri: originalWebUrl,
    });

    if (data.link_data) {
      data.link_data.$canonical_url = data.link_data_$canonical_url || originalWebUrl;
    }

    return { ...data };
  } catch (error) {
    throw error;
  }
});

export const FETCH_ORIGINAL_WEB_URL_LINK_DATA = FetchOriginalWebUrlLinkData.actionNamespaceConstants;

export const fetchOriginalWebUrlLinkData = FetchOriginalWebUrlLinkData.request;

export type FetchOriginalWebUrlLinkDataResponseAction = Action<typeof FETCH_ORIGINAL_WEB_URL_LINK_DATA.response> & {
  data: Record<string, any>;
};
